import { render, staticRenderFns } from "./rateTypeAdd.vue?vue&type=template&id=bdbf330a"
import script from "./rateTypeAdd.vue?vue&type=script&lang=js"
export * from "./rateTypeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports